import DocumentationTagConfiguration from './documentationtagconfiguration'

export default DocumentationTagConfiguration